/* Carrousels de la page Programme (mobile) : repères et signes de vigilance, avec pastilles */
(function () {
  if (window.__phCarousel) return; window.__phCarousel = true;
  function build(el) {
    if (el.getAttribute('data-ph-car')) return; el.setAttribute('data-ph-car', '1');
    var slides = Array.prototype.slice.call(el.children); if (slides.length < 2) return;
    var nav = document.createElement('div'); nav.className = 'ph-car-nav';
    var btns = slides.map(function (s, i) {
      var b = document.createElement('button'), h = s.querySelector('h3'); b.type = 'button'; b.className = 'ph-car-dot';
      b.setAttribute('aria-label', h ? h.textContent.trim() : 'Élément ' + (i + 1));
      b.addEventListener('click', function () { el.scrollTo({ left: s.offsetLeft - parseFloat(getComputedStyle(el).paddingLeft), behavior: 'smooth' }); });
      nav.appendChild(b); return b;
    });
    el.parentNode.insertBefore(nav, el.nextSibling);
    function update() {
      var pad = parseFloat(getComputedStyle(el).paddingLeft) || 0, best = 0, d = 1e9;
      slides.forEach(function (s, i) { var x = Math.abs(s.offsetLeft - pad - el.scrollLeft); if (x < d) { d = x; best = i; } });
      btns.forEach(function (b, i) { b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    }
    var t; el.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update); update(); setTimeout(update, 400);
  }
  function init() { document.querySelectorAll('.ph-reperes .ph-stats, .programmes-article .trio').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
